import { render, staticRenderFns } from "./employeeRoutes.vue?vue&type=template&id=39b36547&scoped=true&"
import script from "./employeeRoutes.vue?vue&type=script&lang=js&"
export * from "./employeeRoutes.vue?vue&type=script&lang=js&"
import style0 from "./employeeRoutes.vue?vue&type=style&index=0&id=39b36547&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b36547",
  null
  
)

export default component.exports